function awaitEndOfScroll(element: Window | HTMLElement = window) {
  return new Promise<void>((resolve) => {
    let timeout: NodeJS.Timeout
    const onScroll = () => {
      if (timeout) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(() => {
        element.removeEventListener('scroll', onScroll)
        resolve()
      }, 100)
    }

    element.addEventListener('scroll', onScroll, { passive: true })
  })
}

export default awaitEndOfScroll
